export default __webpack_public_path__ + "cbc5eb7a1e19e98ba417cc2c1d1aaa72.png";